const RecommendationPoint = ({
  index,
  text,
}: {
  index: number;
  text: string;
}) => {
  return (
    <li className="relative mb-5 flex min-h-[3.3rem] items-center overflow-visible rounded-[10px] bg-[#F2EFE9] font-bold md:mb-6 md:min-h-[5.5rem]">
      <span className="speechBubble z-10 mr-3 text-center text-[20px] md:mr-6 md:text-[42px]">
        {index}
      </span>
      <span
        className="block w-full self-baseline bg-white ml-4 md:ml-6 py-4 pr-3 text-center text-[13px] leading-tight text-[#222222] md:py-7 md:pr-8 md:text-[26px]"
        dangerouslySetInnerHTML={{ __html: text }}
      ></span>
    </li>
  );
};

export default RecommendationPoint;
